import React, { useState, useEffect } from 'react';

const loadingMessages = [
  'Analyzing text…',
  'Extracting meaning…',
  'Matching patterns…',
  'Generating output…',
];

interface RotatingLoadingMessageProps {
  interval?: number;
}

const RotatingLoadingMessage: React.FC<RotatingLoadingMessageProps> = ({
  interval = 2000
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const rotationInterval = setInterval(() => {
      // Fade out
      setIsVisible(false);

      // After fade out, change message and fade in
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % loadingMessages.length);
        setIsVisible(true);
      }, 300); // Match CSS transition duration
    }, interval);

    return () => clearInterval(rotationInterval);
  }, [interval]);

  return (
    <p className={`rotating-message ${isVisible ? 'visible' : 'hidden'}`}>
      {loadingMessages[currentIndex]}
    </p>
  );
};

export default RotatingLoadingMessage;
